// @flow
import * as React from 'react';
import { FormattedNumber } from 'react-intl';

export default function DeliveryModalSectionSubtext(props: {
  status: string,
  count: number,
  isEstimate: boolean,
}): * {
  const { count, status, isEstimate } = props;
  // TODO: move this copy into Apollo
  const baseErrorCopy =
    count === 1 ? (
      `The message couldn’t be delivered to ${count} person.`
    ) : (
      <span>
        The message couldn’t be delivered to <FormattedNumber value={count} /> people.
      </span>
    );
  switch (status) {
    case 'read':
      return (
        <span>
          {count === 1 ? (
            `${count} person received and saw your message.`
          ) : (
            <span>
              <FormattedNumber value={count} /> people received and saw your message.
            </span>
          )}
        </span>
      );
    case 'delivered':
      return (
        <span>
          {count === 1 ? (
            `${count} person received your message.`
          ) : (
            <span>
              <FormattedNumber value={count} /> people received your message.
            </span>
          )}
        </span>
      );
    case 'delivery_error':
      return (
        <span>
          <span>
            {isEstimate && count > 0 ? (
              <span>
                {baseErrorCopy} A list of individual errors is only available for messages sent to
                fewer than 250 people
              </span>
            ) : (
              baseErrorCopy
            )}
          </span>
          <br />
        </span>
      );
    case 'unreachable':
      return (
        <span>
          {count === 1 ? (
            <span>
              The message couldn’t be delivered to {count} person, as they don’t have any enabled
              devices on Remind.
            </span>
          ) : (
            <span>
              The message couldn’t be delivered to <FormattedNumber value={count} /> people, as they
              don’t have any enabled devices on Remind.
            </span>
          )}
        </span>
      );
    case 'unidentifiable':
      return (
        <span>
          {count === 1 ? (
            <span>
              The message was not sent to {count} unidentified student or missing parent or
              guardian.
            </span>
          ) : (
            <span>
              The message was not sent to <FormattedNumber value={count} /> unidentified students or
              missing parents and guardians.
            </span>
          )}
        </span>
      );
    default:
      return '';
  }
}
